import {fork} from "redux-saga/effects";
import authSagas from '../sagas/auth'
import appSagas from '../sagas/index'

export default function* rootSaga(getState) {
    yield fork(authSagas, getState);
    yield fork(appSagas, getState);
}